import { ClipboardList, MessageSquare, Zap, FileCheck, Link2 } from "lucide-react";

export const V1_FEATURE_CARDS = [
  {
    title: "Deal Brief Before the Call",
    desc: "Stakeholders, risks, history, and fresh context from CRM, Slack, calendar, and docs-before you join.",
    image: "/images/deal-brief-before-call.png",
    cardPreview: {
      type: "brief",
      icon: ClipboardList,
      dot: "bg-teal-500",
      accent: "border-l-teal-400",
      response: "Finance lead joined 2 weeks ago; last call flagged budget review in Q2.",
    },
  },
  {
    title: "Live Answers to Tough Questions",
    desc: "Pricing, security, implementation, ROI-answered from your data the moment they ask.",
    image: "/images/live-answers-tough-questions.png",
    cardPreview: {
      type: "live_answer",
      icon: MessageSquare,
      dot: "bg-violet-500",
      accent: "border-l-violet-400",
      response: "Our SOC 2 Type II renewal is March 15; pen test summary is in the security folder.",
    },
  },
  {
    title: "Real-Time Nudges That Move the Deal",
    desc: "Objections, next-best questions, and missing talking points-nudged while you’re still on the call.",
    image: "/images/realtime-nudges-move-deal.png",
    cardPreview: {
      type: "nudge",
      icon: Zap,
      dot: "bg-amber-500",
      accent: "border-l-amber-400",
      response: "You haven’t confirmed champion vs. blocker-ask who signs the order form.",
    },
  },
  {
    title: "Automatic Recap and CRM Updates",
    desc: "Recap, notes, fields, and next steps synced to your CRM as soon as you hang up.",
    image: "/images/automatic-recap-crm-updates.png",
    cardPreview: {
      type: "recap",
      icon: FileCheck,
      dot: "bg-emerald-500",
      accent: "border-l-emerald-400",
      response: "Next step: security questionnaire by Friday · Stage → Evaluation.",
    },
  },
  {
    title: "Connected Deal Context Across Tools",
    desc: "Salesforce, Slack, docs, calendar, and email unified so you’re never selling blind.",
    image: "/images/connected-deal-context.png",
    cardPreview: {
      type: "context",
      icon: Link2,
      dot: "bg-sky-500",
      accent: "border-l-sky-400",
      response: "Slack #acme-deal + last 3 threads + Opportunity notes pulled into this brief.",
    },
  },
];

export const V1_FAQS = [
  {
    question: "Who is Shadow for?",
    answer:
      "Account executives and sales leaders who run live calls where buyers ask sharp, technical, or data-heavy questions-especially when you can’t afford to freeze on a hard question mid-call. If your week is a chain of calls and CRM hygiene, Shadow is meant to sit in that loop with you.",
  },
  {
    question: "Does a bot join my customer calls?",
    answer:
      "No. Shadow works from your desktop-Smart Cards show up on your screen while you run the meeting. Nothing joins Zoom, Meet, or Teams as a separate participant, so you keep a normal buyer experience and avoid the awkward “who is this recorder?” moment.",
  },
  {
    question: "I already keep ChatGPT open-what does Shadow add?",
    answer:
      "Generic chat doesn’t know your account history, tomorrow’s calendar, or what’s in your CRM-and it wasn’t built for sub-second answers while someone is staring at you on video. Shadow is wired into the AE workflow: prep, live guidance grounded on your sources, then recap and CRM updates in one flow instead of copy-paste threads.",
  },
  {
    question: "What context does Shadow actually use?",
    answer:
      "Your connected CRM, calendar, and the knowledge you hook up-so answers can reflect the account, the opportunity, and your materials-not a generic model’s best guess. We’re focused on the stack reps already live in (major meeting platforms, CRMs, and common docs) rather than replacing your system of record.",
  },
  {
    question: "Can I try it before I talk to sales?",
    answer:
      "Yes. Use “See it in action” to run the interactive demo with no signup-you’ll see Smart Cards and real-time nudges in a simulated meeting so you can judge the experience firsthand before creating an account.",
  },
  {
    question: "What languages and meeting platforms do you support?",
    answer:
      "Shadow supports English, Hindi, and Hinglish for natural, mixed conversations. It’s built to work alongside the meeting tools teams already use-including Zoom, Google Meet, and Microsoft Teams-without changing how you invite customers.",
  },
  {
    question: "How do you treat our customer and deal data?",
    answer:
      "We know AE workflows are full of sensitive revenue data. Shadow is built with standard encryption and sensible access boundaries in mind, and we’re happy to walk through security, retention, and vendor review questions with your team when you’re ready to go deeper.",
  },
];

export const V1_HOW_IT_WORKS = [
  {
    step: "01",
    title: "Brief before you join",
    desc: "Open Shadow on your desktop: pre-meeting notes, stakeholder context, and risks-ready before the call starts.",
  },
  {
    step: "02",
    title: "Smart Cards live on the call",
    desc: "Grounded answers to the toughest sales-call questions, plus fact-checks and live nudges-right on screen, with no bot in the meeting.",
  },
  {
    step: "03",
    title: "Recap → CRM → search",
    desc: "When you hang up, capture the recap, sync fields and next steps to your CRM, and search deals and companies in one place.",
  },
];

export const V1_VS_SHADOW = [
  "One workflow from prep to CRM-no stitching tools together",
  "Sub-second Smart Cards when it matters on the call",
  "Grounded in your CRM, docs, and deal history-not a generic model's best guess",
  "Works with your CRM-we update it; we don’t replace it",
];

export const V1_VS_GENERIC = [
  "No awareness of your calendar, pipeline, or account history",
  "Copy a transcript in, re-prompt, wait-lose 10 minutes every call",
  "Sounds smart but misses deal-specific nuance and context",
  "Confident answers with no source-easy to repeat a hallucination out loud",
];
